import React from 'react';
import moment from 'moment';

import NextCheckinMetrics from './metrics/NextCheckinMetrics';

import { history } from '../../state/store';

const PracticeCard = props => {
    const practice = props.practice;
    if (!practice) {
        return <div className="DashboardCard"></div>;
    }

    let className = 'DashboardCard';
    let primaryPracticeDesignator = null;
    if (practice.primary_practice) {
        className = 'DashboardCard PrimaryPractice';
        primaryPracticeDesignator = (
            <p className="primary">
                <i className="fa fa-hospital-o"></i> Primary Practice
            </p>
        );
    }

    return (
        <div
            className={className}
            onClick={() => {
                history.push(`/practice/${practice.id}`);
            }}>
            <div className="DashboardCard__info">
                <div className="DashboardCard__meta">
                    <p className="name">{practice.name}</p>
                    {primaryPracticeDesignator}
                    <p>
                        Status For Next Q-Pass Load Deadline: &nbsp;
                        {practice.events.length > 0
                            ? moment(practice.events[0].date).format(
                                  'YYYY-MM-DD'
                              )
                            : ''}
                        &nbsp; (
                        {practice.events.length > 0
                            ? moment
                                  .duration(
                                      moment(practice.events[0].date) - moment()
                                  )
                                  .humanize()
                            : ''}
                        )
                    </p>
                    <p>
                        <a href={`mailto:${practice.practice_lead}`}>
                            {practice.practice_lead}
                        </a>
                    </p>
                </div>
            </div>

            <div className="DashboardCard__stats">
                <div className="OrganizationMetrics">
                    <NextCheckinMetrics documents={practice.documents} />
                </div>
            </div>
        </div>
    );
};

export default PracticeCard;
